// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TGetLocationsListModel,
  IMappers,
  TGetLocationsListResponse,
  IGetLocationsListResponse,
  IGetLocationsListResponseError,
} from './types';

export const defaultConfig: TGetLocationsListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-constructors',
  pathApi: '/v1/get-locations-list/',
} as TGetLocationsListModel;

export function createGetLocationsListModel(): TGetLocationsListModel {
  return {
    ...defaultConfig,
  };
}

export interface IGetLocationsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetLocationsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetLocationsListOptions<TResponse200, TResponse400>): Promise<
  TGetLocationsListResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetLocationsListModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetLocationsListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetLocationsListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetLocationsListResponse;
}
